import {
  FETCH_KARDEX_REQUEST,
  FETCH_KARDEX_SUCCESS,
  FETCH_KARDEX_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  isFetching: false,
  error: null,
  records: {},
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_KARDEX_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_KARDEX_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        records: action.payload,
      }

    case FETCH_KARDEX_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        records: {},
      }

    default:
      return state
  }
}
